import { Modal } from "react-bootstrap";
import { SelectColumn } from "react-data-grid"
import DataGrid from 'react-data-grid';
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import { useEffect, useReducer, useState } from "react";
import { enumUtil } from "../../../utils/Enum";
import Loader from "../Loader/Loader";
import GridColumnHeader from "../../Setup/Shared/GridColumnHeader";

const PatientSearch = (props) => {
    const { isOpenPatSearch, onClosePatSearch, handleSelectPatient, onRowSelection, rowKeyGetter, selectedRows, type } = { ...props }
    const [searchParam, setSearchParam] = useState('')
    const API_URL_Patient = enumUtil.controller.Patient
    const API_URL_CareGiver = enumUtil.controller.CareGiver
    const [isLoading, setIsLoading] = useState(false)
    const [patientData, setpatientData] = useState([])
    const [recOpened, setRecOpened] = useState(false)
    const [PerPage, setPerPage] = useState("100")
    const [PageNo, setPerPageNo] = useState("1")
    const [TotalPages, setTotalPages] = useState();
    const handlePageClick = (page) => { setPerPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPerPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPerPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPerPageNo(1)
    }
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    const columnsAll = [
        {
            ...SelectColumn,
        },
        {
            key: 'AccountNumber',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Account #'} sortIcon={true} type={'number'} colKey={'AccountNumber'} data={patientData} setData={setpatientData} />),
        },
        {
            key: 'Name',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Name'} sortIcon={true} type={'string'} colKey={'Name'} data={patientData} setData={setpatientData} />),
        },
        {
            key: 'DOB',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Date of Birth'} sortIcon={true} type={'date'} colKey={'DOB'} data={patientData} setData={setpatientData} />),
        },
        {
            key: 'Insured',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={''} headerName={'Insured'} sortIcon={true} type={'string'} colKey={'Insured'} data={patientData} setData={setpatientData} />),
        },
        // { key: 'BalanceDuePat', name: 'Balance due Pat.' },
        // {
        //     key: 'HomePhoneNumber', name: 'Account Phone', cellClass: 'last-column',
        //     headerCellClass: 'last-column',
        // },
    ]
    const LoadData = (searchParam) => {
        setRecOpened(false)
        let SEARCHCRITERIA = {
            "Search": searchParam,
            "SearchType": "All",
        }
        setIsLoading(true);
        let apilink = type === 'CareGiver' ? API_URL_CareGiver + '/CareGiverSearch' : API_URL_Patient + "/PatientSearch"
        let tablename = type === 'CareGiver' ? enumUtil.enumAPITableName.CareGiver : enumUtil.enumAPITableName.Patient
        console.log(apilink, tablename);
        ServerRequestProtected(apilink, 'post', {
            "TableName": tablename,
            "Search": searchParam,
            "SearchType": "All",
            "SEARCHCRITERIA": SEARCHCRITERIA,
            "value": '0',
            'PERPAGE': PerPage,
            'PAGENO': PageNo
        })
            .then((response) => {
                handleGridHeader({ defaultData: response.Rows })
                setpatientData(response.Rows)
                setTotalPages(response.count.NumOfPages);
                setIsLoading(false);
            }).catch((error) => {
                setpatientData([])
                setIsLoading(false);
            })
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            setSearchParam(e.target.value)
            LoadData(e.target.value)
        }
    }
    const onSelectPatientData = () => {
        handleSelectPatient(patientData)
    }
    useEffect(() => {
        let apilink = type === 'CareGiver' ? API_URL_CareGiver + '/CareGiverSearch' : API_URL_Patient + "/PatientSearch"
        let tablename = type === 'CareGiver' ? enumUtil.enumAPITableName.CareGiver : enumUtil.enumAPITableName.Patient
        setRecOpened(true)
        let SEARCHCRITERIA = {
            "Search": searchParam,
            "SearchType": "Recent",
        }
        setIsLoading(true);
        ServerRequestProtected(apilink, 'post', {
            "TableName": tablename,
            "SEARCHCRITERIA": SEARCHCRITERIA,
            "value": '0',
            'PERPAGE': PerPage,
            'PAGENO': PageNo
        })
            .then((response) => {
                handleGridHeader({ defaultData: response.Rows })
                setpatientData(response.Rows)
                setIsLoading(false);
            }).catch((error) => {
                setpatientData([])
                setIsLoading(false);
            })
    }, [])
    return (
        <Modal show={isOpenPatSearch} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 modal-lg hk-modal-v1 master_list_modal ar_palceholder">
            {isLoading ? <Loader /> : null}
            <Modal.Body>
                <div className="d-flex justify-content-lg-between align-items-center hk-modal-header">
                    <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '14px' }}>{type === 'CareGiver' ? 'Caregiver Search' : 'Patient Search'}</p>
                    <button className="btn-icon-transparent" onClick={onClosePatSearch}><i class="icon-x-cros fs-20 dark-clr cursor-pointer"></i></button>
                </div>
                <div className='br-clr'>
                    <div className="row">
                        <div className="col-12 mb-2 mt-2">
                            <div className="input popup_super_search">
                                <div className='input-group hk-input-search'>
                                    <input
                                        type="text"
                                        className='form-control fc-xs'
                                        placeholder='Search by name, DOB, account #, phone #'
                                        value={searchParam}
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter}
                                    />
                                    <span className="input-group-text seraches" id="basic-addon2">
                                        <i className="bi bi-search" onClick={() => LoadData(searchParam)}></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="opened-block ar-grid-border">
                                <p className="heading">{recOpened ? 'Recently Opened' : 'Recently Searched'}</p>
                                <DataGrid
                                    columns={columnsAll}
                                    rows={patientData}
                                    selectedRows={selectedRows}
                                    onSelectedRowsChange={onRowSelection}
                                    rowKeyGetter={rowKeyGetter}
                                    rowHeight={25}
                                    className="all_audit custom_checkboxes_gird fill-grid DataGrid-Table bg-light-blue  sr-table popper-t-table"
                                />
                                {/* <Pagination
                                    PerPage={PerPage}
                                    PageNo={PageNo}
                                    TotalPages={TotalPages}
                                    handlePageClick={handlePageClick}
                                    PreviousPage={PreviousPage}
                                    handleFingByCreteria={handleFingByCreteria}
                                    NextPage={NextPage}
                                /> */}
                            </div>
                        </div>
                        {/* <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-gray" onClick={onClosePatSearch}>Cancel</button>
                            <button className="btn btn-orange " onClick={onSelectPatientData}>Select</button>
                        </div> */}

                    </div>
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClosePatSearch}>Cancel</button>
                <button className='btn btn-validate px-10 h-100' onClick={onSelectPatientData}>Select</button>
            </div>
        </Modal >
    )
}

export default PatientSearch